<template>
  <div slot="header" class="clearfix">
    <el-row :gutter="5">
      <el-col :lg="8">
        {{ title }}
      </el-col>
      <el-col :offset="8" :lg="8" v-if="pagination">
        <PagePagination :total="total" @fetch="fetch" />
      </el-col>
    </el-row>
  </div>
</template>

<script>

import PagePagination from "./PagePagination";

export default {
  name: "PageTitle",
  props: ["title", "total", "pagination"],
  components: {
    PagePagination,
  },
  methods: {
    fetch(records, page) {
      this.$emit("fetch", records, page);
    },
  }
}
</script>